(() => {
  if (window.sbLayerTransition) { window.sbLayerTransition(); return; }
  const clamp = value => Math.max(0, Math.min(1, value));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const auto = el.dataset.mode === 'auto', layers = [...el.querySelectorAll('[data-src]')];
    const hint = el.querySelector('.sblt__hint'), bar = el.querySelector('.sblt__bar');
    let loaded = false, loading, p = 0, done = false, down = null, dragged = false, played = false, raf = 0;
    function set(value) {
      p = clamp(value);
      if (!loaded) return;
      layers[0].style.opacity = clamp(p * 2);
      layers[1].style.opacity = clamp((p - .5) * 2);
      if (bar) bar.style.width = p * 100 + '%';
      if (p > .9) done = true;
    }
    function load() {
      if (loading) return loading;
      loading = Promise.all(layers.map(image => new Promise((resolve, reject) => {
        image.onload = () => (image.decode ? image.decode() : Promise.resolve()).then(resolve, reject);
        image.onerror = reject;
        image.src = image.dataset.src;
      }))).then(() => { loaded = true; set(p); }).catch(() => { loading = null; throw new Error('Transition images unavailable'); });
      return loading;
    }
    function play() {
      if (played) return;
      played = true;
      load().then(() => {
        if (reduced.matches) { set(1); return; }
        let start;
        const tick = time => {
          if (!el.isConnected) return;
          if (reduced.matches) { set(1); return; }
          start ??= time; set((time - start) / 2500);
          if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
      }).catch(() => { played = false; });
    }
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        if (auto) play(); else load().catch(() => {});
      }, {threshold:.15});
      observer.observe(el);
    } else if (auto) play();
    if (auto) {
      /* Turbo 28.10.: Play-Button unten links spielt die Ueberblendung erneut ab, ohne die Lightbox zu oeffnen */
      const replay = el.querySelector('[data-sblt-replay]');
      if (replay) {
        const again = event => {
          event.preventDefault(); event.stopPropagation();
          cancelAnimationFrame(raf); played = false; set(0); play();
        };
        replay.addEventListener('click', again);
        replay.addEventListener('pointerdown', event => event.stopPropagation());
        replay.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') again(event); });
      }
      reduced.addEventListener?.('change', () => { if (reduced.matches) { cancelAnimationFrame(raf); load().then(() => set(1)).catch(() => {}); } });
      return; // Do not intercept any gallery pointer/swipe gestures.
    }
    const link = el.closest('a');
    function move(event) {
      const rect = el.getBoundingClientRect();
      set((event.clientX - rect.left) / Math.max(1, rect.width));
    }
    function back() { if (hint && !done) hint.classList.remove('off'); }
    el.addEventListener('pointerenter', event => {
      load().catch(() => {});
      if (event.pointerType === 'mouse') hint?.classList.add('off');
    });
    el.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      dragged = false; down = {x:event.clientX,y:event.clientY,id:event.pointerId};
      hint?.classList.add('off'); load().catch(() => {});
      if (event.pointerType !== 'mouse') move(event);
    });
    el.addEventListener('pointermove', event => {
      if (down) {
        const dx = Math.abs(event.clientX-down.x), dy = Math.abs(event.clientY-down.y);
        if (dy > dx && dy > 8) { down = null; return; }
        if (dx > 8) { dragged = true; el.setPointerCapture?.(event.pointerId); }
      }
      if (event.pointerType === 'mouse' || down) move(event);
    });
    el.addEventListener('pointerup', () => { down = null; back(); });
    el.addEventListener('pointerleave', back);
    el.addEventListener('pointercancel', () => { down = null; dragged = false; back(); });
    el.addEventListener('dragstart', event => event.preventDefault());
    if (link) {
      link.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); dragged = false; } }, true);
      link.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const value = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : p + (event.key === 'ArrowRight' ? .1 : -.1);
        load().then(() => set(value)).catch(() => {});
      });
    }
  }
  const boot = window.sbLayerTransition = () => document.querySelectorAll('[data-sblt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
